﻿import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { LogOut, User, RefreshCw, HelpCircle, Settings } from "lucide-react";

import { authLogout } from "@/redux/actions/auth.actions";
import { initialText, validRoles } from "@/services/Utils";

import classes from "@/components/desktop/header/header.module.scss";

const HeaderMenu = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const { user } = useSelector((state) => state.auth);

	const refDiv = useRef(null);
	const refButton = useRef(null);

	const [showMenu, setShowMenu] = useState(false);

	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isEstateManager = validRoles(userRoles, ["administrador", "gerente_agricola", "administrador_campo"]);

	const handleClickOutside = (event) => {
		if (refButton.current && !refButton.current.contains(event.target) && refDiv.current && !refDiv.current.contains(event.target)) {
			setShowMenu(false);
		}
	};

	const handleMenu = () => {
		setShowMenu(!showMenu);
	};

	const handleLogOut = () => {
		dispatch(authLogout());
	};

	useEffect(() => {
		document.addEventListener("click", handleClickOutside, true);
		return () => {
			document.removeEventListener("click", handleClickOutside, true);
		};
	}, []);

	return (
		<>
			<div className={`${classes.item} ${classes.base}`} onClick={handleMenu} ref={refButton}>
				<div style={{ textAlign: "center" }}>
					<div>{user && initialText(user.full_name)}</div>
				</div>
			</div>
			<div className={`${classes.dropdown_menu}`} ref={refDiv} style={{ display: showMenu ? "initial" : "none" }} id="profile-dropdown">
				<ul>
					<li
						onClick={() => {
							handleMenu();
							navigate("/perfil");
						}}
					>
						<User className={`${classes.icon}`} size={18} strokeWidth={2} />
						<div>
							<div> {user && user.full_name}</div>
							<div className={classes.subtitle}>{user && user.customer && user.customer.name}</div>
						</div>
					</li>

					<li
						onClick={() => {
							handleMenu();
							navigate("/soporte/actualizaciones");
						}}
					>
						<RefreshCw className={`${classes.icon}`} size={18} strokeWidth={2} />
						Actualizaciones
					</li>
					<li
						onClick={() => {
							handleMenu();
						}}
					>
						<HelpCircle className={`${classes.icon}`} size={18} strokeWidth={2} />
						<a href="https://ayuda.agroinventario.cl/" target="__blank">
							Centro de ayuda
						</a>
					</li>
					{!!isEstateManager && (
						<li
							onClick={() => {
								handleMenu();
								navigate("/configuracion");
							}}
							id="profile-configuration"
						>
							<Settings className={`${classes.icon}`} size={18} strokeWidth={2} />
							Configuración
						</li>
					)}

					<li onClick={() => handleLogOut()}>
						<LogOut className={`${classes.icon}`} size={18} strokeWidth={2} />
						Cerrar Sesión
					</li>
				</ul>
			</div>
		</>
	);
};

export default HeaderMenu;
